import { render } from "./QwilrDefinitionField.vue?vue&type=template&id=2ef93a3c&scoped=true"
import script from "./QwilrDefinitionField.vue?vue&type=script&lang=js"
export * from "./QwilrDefinitionField.vue?vue&type=script&lang=js"

import "./QwilrDefinitionField.vue?vue&type=style&index=0&id=2ef93a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef93a3c"]])

export default __exports__